import { useTranslations } from 'next-intl'

import { ManageWebPushNotificationSubscriptionSection } from '@/components/web-push-notification/manage-web-push-notification-subscription-section'

import { MOBILE_SETUP_TUTORIAL_LINK } from '@/constants/common'

import { GenericTutorialGuideButton } from '../common/generic-tutorial-guide-button'

import { PreferencesSectionHeader } from './preferences-section-header'

const NotificationTab = () => {
  const t = useTranslations('UserPreferences')
  return (
    <div className="flex h-full flex-col">
      <PreferencesSectionHeader
        title={t('notifications.title')}
        description={t('notifications.description')}
        titleClassName="text-lg font-semibold tracking-tight"
      />
      <ManageWebPushNotificationSubscriptionSection />
      <div className="flex items-center justify-start p-6">
        <GenericTutorialGuideButton tutorialLink={MOBILE_SETUP_TUTORIAL_LINK} className="w-fit" />
      </div>
    </div>
  )
}
NotificationTab.displayName = 'NotificationTab'

export { NotificationTab }
